import { Button } from "ui/components/button";
import Icon from "../icon";
import { PLUS } from "icons";
import { encodeDateToOffset } from "./utils";
import { Link, useNavigate } from "react-router-dom";
import { useTimesheet } from "./context";
import AddLogCard from "./card/add-log";

export function AddLogButton({ children, href, variant }) {
  const { date } = useTimesheet();

  if (typeof children === "function") {
    return children({ date });
  }

  if (href) {
    return (
      <Link to={href}>
        <Button>
          {children ? (
            children
          ) : (
            <>
              <Icon icon={PLUS} />
              Add Log
            </>
          )}
        </Button>
      </Link>
    );
  }

  return (
    <Link to={href ? href : `/timesheet/logs/+?date=${date}`}>
      <Button variant={variant}>
        {children ? (
          children
        ) : (
          <>
            <Icon icon={PLUS} />
            Add Log
          </>
        )}
      </Button>
    </Link>
  );
}

export function AddLog({ children, href, className }) {
  const { date } = useTimesheet();

  if (typeof children === "function") {
    return children({ date });
  }
  return (
    <AddLogCard
      href={href ? href : `/timesheet/logs/+?date=${date}`}
      className={className}
    />
  );
}
